import React from 'react'
import { Column } from 'primereact/column'
import BadgeBodyTemplate from './BadgeBodyTemplate'
import { createColumnAttributes } from '../utils/createColumnAttributes'
import { getRowClassName } from '../utils/getRowClassName'

const MembershipTypesColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, template, originalData }) => {
    const { filterAttributes, sortAttributes, checkFieldChanged } = createColumnAttributes({
        filter,
        title,
        sortable,
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            body={(rowData) => (
                <span className={getRowClassName(checkFieldChanged, rowData)}>
                    {template ? template(rowData) : <BadgeBodyTemplate rowData={rowData} field={mapsToField} />}
                </span>
            )}
            editor={null}
            {...filterAttributes}/>
    )
}

export default MembershipTypesColumn
